import { HTTP } from "./axios";
import { tokenExists } from "@/utilities/session";
import { JSConn } from "@/utilities/js-conn";

export interface ItemDetails {
  pluralName: string;
  singularName: string;
}

const urlBuilder = (itemDetails: ItemDetails) => {
  return "/" + itemDetails.pluralName;
};

const headersBuilder = () => {
  const token = tokenExists();

  if (token) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  } else {
    return {
      headers: {
        Authorization: "Bearer",
      },
    };
  }
};

const logInUser = (jsConn: JSConn): Promise<JSConn> => {
  return new Promise((resolve, reject) => {
    HTTP.post("/auth", {
      ...jsConn.apiParams,
    })
      .then((response: any) => {
        jsConn.response = response["data"];
        jsConn.apiCallStatus = "ok";
        resolve(jsConn);
      })
      .catch((e: any) => {
        jsConn.error = e;
        reject(jsConn);
      });
  });
};

const updateSession = (jsConn: JSConn): Promise<JSConn> => {
  return new Promise((resolve, reject) => {
    HTTP.patch(
      "/auth",
      {
        ...jsConn.apiParams,
      },
      headersBuilder(),
    )
      .then((response: any) => {
        jsConn.response = response["data"];
        resolve(jsConn);
      })
      .catch((e: any) => {
        jsConn.apiCallStatus = "error";
        jsConn.error = e;
        reject(jsConn);
      });
  });
};

const getItems = (
  jsConn: JSConn,
  itemDetails: ItemDetails,
): Promise<JSConn> => {
  const apiUrl = urlBuilder(itemDetails);

  return new Promise((resolve, reject) => {
    const config = {
      params: {
        ...jsConn.apiParams,
      },
      ...headersBuilder(),
    };

    HTTP.get(apiUrl, config)
      .then((response: any) => {
        jsConn.response = response["data"];
        jsConn.apiCallStatus = "ok";
        resolve(jsConn);
      })
      .catch((e: any) => {
        jsConn.apiCallStatus = "error";
        jsConn.error = e;
        reject(jsConn);
      });
  });
};

const deleteItem = (
  jsConn: JSConn,
  itemDetails: ItemDetails,
): Promise<JSConn> => {
  const apiUrl = urlBuilder(itemDetails);

  return new Promise((resolve, reject) => {
    HTTP.delete(apiUrl + "/" + jsConn.apiParams.id, headersBuilder())
      .then((response: any) => {
        jsConn.response = response["data"];
        jsConn.apiCallStatus = "ok";
        resolve(jsConn);
      })
      .catch((e: any) => {
        jsConn.apiCallStatus = "error";
        jsConn.error = e;
        reject(jsConn);
      });
  });
};

const getItem = (jsConn: JSConn, itemDetails: ItemDetails): Promise<JSConn> => {
  const apiUrl = urlBuilder(itemDetails);
  jsConn.apiParams = jsConn.formParams;

  return new Promise((resolve, reject) => {
    HTTP.get(apiUrl + "/" + jsConn.apiParams.id, headersBuilder())
      .then((response: any) => {
        jsConn.response = response["data"];
        jsConn.apiCallStatus = "ok";
        resolve(jsConn);
      })
      .catch((e: any) => {
        jsConn.apiCallStatus = "error";
        jsConn.error = e;
        reject(jsConn);
      });
  });
};

const createItem = (
  jsConn: JSConn,
  itemDetails: ItemDetails,
): Promise<JSConn> => {
  const apiUrl = urlBuilder(itemDetails);

  return new Promise((resolve, reject) => {
    HTTP.post(apiUrl, jsConn.apiParams, headersBuilder())
      .then((response: any) => {
        jsConn.response = response["data"];
        jsConn.apiCallStatus = "ok";
        resolve(jsConn);
      })
      .catch((e: any) => {
        jsConn.apiCallStatus = "error";
        jsConn.error = e;
        reject(jsConn);
      });
  });
};

const uploadFile = (
  jsConn: JSConn,
  itemDetails: ItemDetails,
): Promise<JSConn> => {
  const apiUrl = urlBuilder(itemDetails);

  return new Promise((resolve, reject) => {
    HTTP.post(apiUrl, jsConn.apiParams, headersBuilder())
      .then((response: any) => {
        jsConn.response = response["data"];
        jsConn.apiCallStatus = "ok";
        resolve(jsConn);
      })
      .catch((e: any) => {
        jsConn.apiCallStatus = "error";
        jsConn.error = e;
        reject(jsConn);
      });
  });
};

const updateItem = (
  jsConn: JSConn,
  itemDetails: ItemDetails,
): Promise<JSConn> => {
  const apiUrl = urlBuilder(itemDetails);

  return new Promise((resolve, reject) => {
    HTTP.patch(
      apiUrl + "/" + jsConn.apiParams["id"],
      jsConn.apiParams,
      headersBuilder(),
    )
      .then((response: any) => {
        jsConn.response = response["data"];
        jsConn.apiCallStatus = "ok";
        resolve(jsConn);
      })
      .catch((e: any) => {
        jsConn.apiCallStatus = "error";
        jsConn.error = e;
        reject(jsConn);
      });
  });
};

export default {
  createItem,
  deleteItem,
  getItem,
  getItems,
  logInUser,
  updateItem,
  updateSession,
  uploadFile,
};
